<div
  class="register-container surface-ground flex align-items-center justify-content-center min-h-screen">
  <div class="w-full flex flex-column justify-content-between">
    <div class="text-center my-4">
      <div class="logo-teorema"></div>
    </div>

    <div class="w-full">
      <ng-template #messages>
        @if (message) {
          <patron-alert color="info">{{ message }}</patron-alert>
        }
        @if (errorMessage) {
          <patron-alert color="danger">{{ errorMessage }}</patron-alert>
        }
      </ng-template>

      @switch (activeStep) {
        @case ('register-email') {
          <div class="register-email surface-card p-4 sm:p-8 border-round-lg shadow-2 mb-6 mx-auto">
            <h1 class="text-2xl sm:text-3xl mb-2 text-center">Experimente grátis</h1>
            <p class="mb-4 text-center text-sm sm:text-base">Comece a vender mais e melhor.</p>
            <ng-container *ngTemplateOutlet="messages"></ng-container>
            <patron-form [formGroup]="registerEmailForm" (onSubmit)="registerEmail()">
              <patron-form-field
                [formGroup]="registerEmailForm"
                formControlName="email"
                label="Email"
                placeholder="exemplo@seuemail.com"
                size="lg">
              </patron-form-field>
              <div class="mt-6">
                <patron-button
                  type="submit"
                  color="success"
                  size="lg"
                  [loading]="loading"
                  customStyle="width: 100%"
                  customClass="login-button flex justify-content-center font-medium"
                  class="w-full">
                  Criar conta
                </patron-button>
              </div>
              <p class="mt-4 text-center text-sm">
                Já tem uma conta?
                <a class="font-medium text-indigo-600 hover:text-indigo-500" routerLink="/">
                  Entrar
                </a>
              </p>
            </patron-form>
          </div>
        }
        @case ('validate-code') {
          <div
            class="validate-code surface-card p-4 sm:p-8 border-round-lg shadow-2 mb-6 mx-auto fadein animation-duration-300">
            <h1 class="text-2xl sm:text-3xl mb-2 text-center">Experimente grátis</h1>
            <p class="mb-4 text-center text-sm sm:text-base">Comece a vender mais e melhor.</p>
            <ng-container *ngTemplateOutlet="messages"></ng-container>
            <patron-form [formGroup]="validateCodeForm" (onSubmit)="validateCode()">
              <patron-form-field
                [formGroup]="validateCodeForm"
                formControlName="email"
                label="Email"
                size="lg">
              </patron-form-field>
              <patron-form-field
                [formGroup]="validateCodeForm"
                formControlName="code"
                label="Código"
                size="lg">
              </patron-form-field>
              <p class="mt-4 text-center text-sm">
                <a
                  class="font-medium text-indigo-600 hover:text-indigo-500"
                  href="javascript:void(0)"
                  (click)="enableResendEmail()">
                  Não recebi o código
                </a>
              </p>
              <div class="mt-6">
                <patron-button
                  type="submit"
                  color="success"
                  size="lg"
                  [loading]="loading"
                  customStyle="width: 100%"
                  customClass="login-button flex justify-content-center font-medium"
                  class="w-full">
                  Validar
                </patron-button>
              </div>
            </patron-form>
          </div>
        }
        @case ('register-user') {
          <div
            class="register-user surface-card p-4 sm:p-8 border-round-lg shadow-2 mb-6 mx-auto fadein animation-duration-300">
            <h1 class="text-2xl sm:text-3xl mb-2 text-center">Experimente grátis</h1>
            <p class="mb-4 text-center text-sm sm:text-base">Comece a vender mais e melhor.</p>
            <patron-steps [model]="steps" [activeIndex]="0" styleClass="mb-4"></patron-steps>
            <ng-container *ngTemplateOutlet="messages"></ng-container>
            <patron-form [formGroup]="registerUserForm" (onSubmit)="registerUser()">
              <patron-form-field
                [formGroup]="registerUserForm"
                formControlName="email"
                label="Email">
              </patron-form-field>
              <patron-form-field [formGroup]="registerUserForm" formControlName="name" label="Nome">
              </patron-form-field>
              <patron-form-field
                [formGroup]="registerUserForm"
                formControlName="password"
                label="Senha"
                type="password">
              </patron-form-field>
              <patron-form-field
                [formGroup]="registerUserForm"
                formControlName="password_confirmation"
                label="Confirme a senha"
                type="password">
              </patron-form-field>
              <div class="mt-6">
                <patron-button
                  type="submit"
                  color="success"
                  size="lg"
                  [loading]="loading"
                  customStyle="width: 100%"
                  customClass="login-button flex justify-content-center font-medium"
                  class="w-full">
                  Avançar
                </patron-button>
              </div>
            </patron-form>
          </div>
        }
        @case ('register-company') {
          <div
            class="register-company surface-card p-4 sm:p-8 border-round-lg shadow-2 mb-6 mx-auto fadeinright animation-duration-300">
            <h1 class="text-2xl sm:text-3xl mb-2 text-center">Experimente grátis</h1>
            <p class="mb-4 text-center text-sm sm:text-base">Comece a vender mais e melhor.</p>
            <patron-steps [model]="steps" [activeIndex]="1" styleClass="mb-4"></patron-steps>
            <ng-container *ngTemplateOutlet="messages"></ng-container>
            <patron-form [formGroup]="registerCompanyForm" (onSubmit)="registerCompany()">
              <patron-form-field
                [formGroup]="registerCompanyForm"
                formControlName="cnpj"
                label="CNPJ"
                type="mask"
                mask="00.000.000/0000-00"
                (handleBlur)="changeCnpj()">
              </patron-form-field>
              <patron-form-field
                [formGroup]="registerCompanyForm"
                formControlName="name"
                label="Nome da empresa">
              </patron-form-field>
              <patron-form-field
                [formGroup]="registerCompanyForm"
                formControlName="fantasy_name"
                label="Nome fantasia">
              </patron-form-field>
              <patron-form-field
                [formGroup]="registerCompanyForm"
                formControlName="phone"
                label="Telefone"
                type="mask"
                placeholder="(xx) x xxxx-xxxx"
                mask="(00) 0 0000-0000||(00) 0000-0000||(00) 000-0000">
              </patron-form-field>
              <patron-form-field
                [formGroup]="registerCompanyForm"
                formControlName="ie"
                label="Inscrição Estadual">
              </patron-form-field>
              <patron-select
                [formGroup]="registerCompanyForm"
                formControlName="ie_dest_ind"
                bindLabel="label"
                bindValue="value"
                label="Indicador IE destinatário"
                [items]="ieDestInds">
              </patron-select>
              <patron-select
                [formGroup]="registerCompanyForm"
                formControlName="tax_regime"
                bindLabel="label"
                bindValue="value"
                label="Regime de tributação"
                [items]="taxRegimes">
              </patron-select>
              <p class="mt-4 text-center text-sm">
                <a
                  class="font-medium text-indigo-600 hover:text-indigo-500"
                  href="javascript:void(0)"
                  (click)="goToStep({ step: 'register-user' })">
                  &lt; Voltar
                </a>
              </p>
              <div class="mt-6">
                <patron-button
                  type="submit"
                  color="success"
                  size="lg"
                  [loading]="loading"
                  customStyle="width: 100%"
                  customClass="login-button flex justify-content-center font-medium"
                  class="w-full">
                  Avançar
                </patron-button>
              </div>
            </patron-form>
          </div>
        }
        @case ('register-address') {
          <div
            class="register-address surface-card p-4 sm:p-8 border-round-lg shadow-2 mb-6 mx-auto fadeinright animation-duration-300">
            <h1 class="text-2xl sm:text-3xl mb-2 text-center">Experimente grátis</h1>
            <p class="mb-4 text-center text-sm sm:text-base">Comece a vender mais e melhor.</p>
            <patron-steps [model]="steps" [activeIndex]="2" styleClass="mb-4"></patron-steps>
            <ng-container *ngTemplateOutlet="messages"></ng-container>
            <patron-form [formGroup]="registerAddressForm" (onSubmit)="registerAddress()">
              <patron-form-field
                [formGroup]="registerAddressForm"
                formControlName="cep"
                label="CEP"
                type="mask"
                mask="00.000-000"
                (handleBlur)="changeCep()">
              </patron-form-field>
              <patron-form-field
                [formGroup]="registerAddressForm"
                formControlName="address"
                label="Endereço">
              </patron-form-field>
              <patron-form-field
                [formGroup]="registerAddressForm"
                formControlName="number"
                label="Número">
              </patron-form-field>
              <patron-form-field
                [formGroup]="registerAddressForm"
                formControlName="complement"
                label="Complemento">
              </patron-form-field>
              <patron-form-field
                [formGroup]="registerAddressForm"
                formControlName="neighborhood"
                label="Bairro">
              </patron-form-field>
              <patron-select
                [formGroup]="registerAddressForm"
                formControlName="city"
                label="Cidade"
                bindLabel="_name"
                orderBy="name"
                modelName="cities">
              </patron-select>
              <p class="mt-4 text-center text-sm">
                <a
                  class="font-medium text-indigo-600 hover:text-indigo-500"
                  href="javascript:void(0)"
                  (click)="goToStep({ step: 'register-company' })">
                  &lt; Voltar
                </a>
              </p>
              <div class="mt-6">
                <patron-button
                  type="submit"
                  color="success"
                  size="lg"
                  [loading]="loading"
                  customStyle="width: 100%"
                  customClass="login-button flex justify-content-center font-medium"
                  class="w-full">
                  Finalizar cadastro
                </patron-button>
              </div>
            </patron-form>
          </div>
        }
      }
    </div>

    <footer class="mt-10 text-center text-xs">
      <p>© 2025 Vendor. Todos os direitos reservados.</p>
    </footer>
  </div>

  @if (loadingData) {
    <patron-overlay></patron-overlay>
  }

  <patron-modal
    [visible]="successModalVisible"
    title="Sucesso!"
    [footerTemplate]="footerTemplate"
    (visibleChanged)="successModalVisibleChanged($event)">
    <div class="text-center">
      <patron-icon name="bi-check-circle"></patron-icon>
      <h6>Seu cadastro foi criado!</h6>
    </div>

    <ng-template #footerTemplate>
      <div class="w-full text-center">
        <patron-button size="lg" color="success" routerLink="/"> Acessar o sistema </patron-button>
      </div>
    </ng-template>
  </patron-modal>
</div>
